import { Box, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { publicColors, publicContainerSx } from './publicTheme';

const Footer = () => (
    <Box
        component="footer"
        sx={{
            bgcolor: publicColors.ink,
            color: 'rgba(255,255,255,0.85)',
            py: 5,
            borderTop: `1px solid ${publicColors.border}`,
        }}
    >
        <Box sx={publicContainerSx}>
            <Grid container spacing={4} justifyContent="space-between">
                <Grid item xs={12} md={7}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#fff', mb: 1 }}>
                        Acompanha 3D
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.65, maxWidth: 480 }}>
                        <strong>Gestão orientada por dados para quem produz e vende impressão 3D.</strong>
                        <br />
                        <br />
                        Métricas, estatísticas e ferramentas para transformar dados da sua operação em decisões melhores sobre produção, custos, precificação, vendas e rentabilidade.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Typography sx={{ fontWeight: 600, color: '#fff', mb: 1 }}>De maker para maker</Typography>
                    <Typography variant="body2">Curitiba — Brasil</Typography>
                </Grid>
            </Grid>
            <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.12)', mt: 4, pt: 3, textAlign: 'center' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap', mb: 2 }}>
                    <Link
                        component={RouterLink}
                        to="/termos-de-uso"
                        variant="caption"
                        sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
                    >
                        Termos de Uso
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/politica-de-privacidade"
                        variant="caption"
                        sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
                    >
                        Política de Privacidade
                    </Link>
                </Box>
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.55)' }}>
                    © {new Date().getFullYear()} Acompanha 3D · Uma solução de Andrebian Soluções Web (CNPJ 23.558.573/0001-30)
                </Typography>
            </Box>
        </Box>
    </Box>
);

export default Footer;
